<template>
	<section class="pt-60" id="about">
		<div class="container">
			<div class="row mt-4">
				<div id="about-title" class="col-md-12" contenteditable="false" v-html="quarkRead('about-title')"></div>
			</div>
			<div class="row mb-5">
				<div id="about-content" class="col-md-6" contenteditable="false">
					<p>xplorex GmbH develops and produces X-ray analytical systems, for quick analysis on-site.</p>
					<p>The company consists of the following parties:</p>
					<p>&nbsp;</p>
					<div class="row">
						<div class="col-md-4 d-flex align-items-center">
							<a href="http://www.xhuber.com" target="_blank">
								<img class="img-fluid p-3" src="images/logo-huber.jpg" />
							</a>
						</div>
						<!-- <div class="col-md-4 d-flex align-items-center">
							<a href="http://www.focussing.nl" target="_blank">
								<img class="img-fluid p-3" src="images/logo-focussing.png" />
							</a>
						</div> -->
						<div class="col-md-4 d-flex align-items-center">
							<a href="http://www.ajk-analytical.com" target="_blank">
								<img class="img-fluid p-3" src="images/logo-ajk.jpg" />
							</a>
						</div>
					</div>
					<p>&nbsp;</p>
					<p>Together we represent more than 50 years of experience in X-ray diffraction.</p>
				</div>
				<div class="col-md-6">
					<img class="img-fluid" :src="movie[2].poster" alt="movie3" @click="playMovie(2)" />
				</div>
			</div>
		</div>

		<div class="container">
			<div class="row mb-3">
				<div class="col-md-12">
					<h2>Look at our videos!</h2>
					<br />
				</div>
				<div class="col-md-6">
					<img class="img-fluid" :src="movie[0].poster" alt="movie1" @click="playMovie(0)" />
				</div>
				<div class="col-md-6">
					<img class="img-fluid" :src="movie[1].poster" alt="movie2" @click="playMovie(1)" />
				</div>
			</div>
		</div>

		<!-- Modal Component -->
		<b-modal id="videoModalRef" size="lg" :title="movieTitle" :hide-header="false" :hide-footer="true" @hide="stopMovie">
			<div class="embed-responsive embed-responsive-16by9">
				<iframe :src="played" class="embed-responsive-item"></iframe>
			</div>
		</b-modal>
	</section>
</template>
<script>
import axios from 'axios';
import { Carousel, Slide } from 'vue-carousel';

export default {
	data: () => ({
		baseUrl: '/db-sqlite.php',

		images: [],
		movie: [
			// https://www.thewebtaylor.com/articles/how-to-get-a-youtube-videos-thumbnail-image-in-high-quality
			{
				title: 'xplorex Documentary',
				href: 'https://www.youtube.com/embed/1X1SFrOwY4o',
				poster: 'images/video0.jpg'
			},
			{
				title: 'High Resolution XRD Powder Diffraction',
				href: 'https://www.youtube.com/embed/AauFlzmMniA',
				poster: 'images/video1.jpg'
			},
			{
				title: 'The xplorex Team',
				href: 'https://www.youtube.com/embed/YZP33Er376Q',
				poster: 'images/video2.jpg'
			},
			{
				title: 'Brixlegg archeological site',
				href: 'https://www.youtube.com/embed/RN6ndxr8KYI',
				poster: 'images/video3.jpg'
			}
		],
        movieTitle: '',
        played: '',
		index: null,
		content: []
	}),

	components: {
		Carousel,
		Slide
	},

	created() {
        console.clear();
		axios
			.get(this.baseUrl + '/quark_table')
			.then(response => {
				this.content = response.data;
				for (var i = 0; i < this.content.length; i++) {
					//this.content[i].content = this.content[i].content.split('img-responsive').join('img-fluid');
					// this.content[i].content = this.content[i].content.replace(/<([^ >]+)[^>]*>/ig, '<$1>');
					// this.content[i].content = this.content[i].content.split('<table>').join('<table class="table  table-bordered">');
				}
				//console.log(this.content[0].content);
			})
			.catch(e => {
				// this.errors.push(e)
				console.log(e);
			});
	},

	methods: {
		quarkRead(section) {
			var content;
			for (var i = 0; i < this.content.length; i++) {
				if (this.content[i].section == section) {
					content = this.content[i].content;
					break;
				}
			}

			return content;
		},

		playMovie(movieNr) {
			this.played = this.movie[movieNr].href;
			this.movieTitle = this.movie[movieNr].title;
			this.$bvModal.show('videoModalRef');
		},

		stopMovie() {
			// stop movie by setting the iframe's src attribute
			this.played = '';
		}
	}
};
</script>